module.exports = __webpack_public_path__ + "static/laboheme2s-6fc26c866bb89062e06548c52f69d885.jpg";